module.exports = "/_next/static/images/3d85adfee6874733963a3afcbcc364c7-openBankingConfirmation.svg.webp";